import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  ActivatedRoute,
  IsActiveMatchOptions,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { IconName } from "app/shared/models/icon-name.type";
import { NgClass, NgIf } from "@angular/common";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";
import { EllipsisTitleDirective } from "app/shared/directives/ellipsis-title.directive";

// Parent has item level 1, children level 2...
export type ItemLevel = "1" | "2" | "3" | "4";

@Component({
  selector: "sidenav-item",
  templateUrl: "./sidenav-item.component.html",
  styleUrls: ["./sidenav-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    RouterLinkActive,
    RouterLink,
    SvgComponent,
    NgIf,
    EllipsisTitleDirective,
  ],
})
export class SidenavItemComponent {
  // routerLink has the same type as in the router.d.ts file
  @Input() public itemRouterLink: any[] | string;
  @Input() public itemRouterLinkActiveOptions: { exact: boolean } = {
    exact: true,
  };
  @Input() public itemLevel: ItemLevel = "1";
  @Input() public itemTitle: string;
  @Input() public hasSubItems: boolean = false;
  @Input() public icon?: IconName;
  @Input() public e2e?: string;

  @Output() public itemClicked: EventEmitter<void> = new EventEmitter<void>();

  public isClientSidenavItem: boolean = false;

  @HostBinding("class") get hostClasses(): string {
    let classes: string = "sidenav-item";
    if (this.hasSubItems) {
      classes += " sidenav-item--parent";
    }
    return classes;
  }

  constructor(public router: Router) {}

  /**
   * Emit to parent when sidenav item has been clicked
   */
  public sideNavItemClicked(): void {
    this.logAnalyticEvent();
    if (!this.hasSubItems) {
      this.itemClicked.emit();
    }
  }

  private logAnalyticEvent(): void {}
}
